/** The circular-arrow glyph of the app pickers' "Synchronize Now" button.
 *  One component so every refresh affordance (Ads Manager / Overview
 *  pickers, Campaign Studio device-support refresh) looks the same. */
export function SyncGlyph({
  spinning = false,
  size = 14,
}: {
  spinning?: boolean;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      style={
        spinning
          ? { animation: "spin 1.05s linear infinite", transformOrigin: "center" }
          : undefined
      }
    >
      <path
        d="M8 2.5a5.5 5.5 0 1 1-5.42 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M2.5 4 5 4.5l-.5 2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
